import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { NitriteSensorNodeModel } from './NitriteSensorNodeModel';
import { NitriteSensorNodeWidget } from './NitriteSensorNodeWidget';

export class NitriteSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.NitriteSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new NitriteSensorNodeModel();
  }

  nodeUI(event) {
    return <NitriteSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
